import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuid } from 'uuid';

type Color = 'info' | 'success' | 'warning' | 'danger';
export interface Toast {
  id: string,
  color: Color
  message: string
  header: string
  delay?: number
  autohide?: boolean
  fade?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  private get toasts(): Toast[] {
    return this.toastsSubject.value;
  }

  show(toast: Omit<Toast, 'id'>) {
    // Prevent duplicate toasts with the same header
    const isDuplicate = this.toasts.some(t => t.header === toast.header);
    if (isDuplicate) return;

    const newToast: Toast = { ...toast, id: uuid() };
    this.toastsSubject.next([...this.toasts, newToast]);
  }

  remove(id: Toast['id']) {
    this.toastsSubject.next(this.toasts.filter((t) => t.id !== id));
  }

  // Cierra todos los toasts que tengan el header indicado. 
  removeByHeader(header: string) {
    this.toastsSubject.next(this.toasts.filter((t) => t.header !== header));
  }
}
